import { render, staticRenderFns } from "./MailServicePageListStatusColumn.vue?vue&type=template&id=64c8f128"
import script from "./MailServicePageListStatusColumn.vue?vue&type=script&lang=js"
export * from "./MailServicePageListStatusColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports